import { reactive } from 'vue'

const state = reactive({ items: [] })
let sequence = 0

function show(message, type = 'info', options = {}) {
  const id = ++sequence
  const item = {
    id,
    message: String(message || ''),
    type,
    duration: Number(options.duration ?? 3600)
  }
  state.items.push(item)
  if (item.duration > 0) window.setTimeout(() => dismiss(id), item.duration)
  return id
}

function dismiss(id) {
  const index = state.items.findIndex((item) => item.id === id)
  if (index >= 0) state.items.splice(index, 1)
}

export function useToast() {
  return {
    state,
    show,
    dismiss,
    success: (message, options) => show(message, 'success', options),
    error: (message, options) => show(message, 'error', options),
    warning: (message, options) => show(message, 'warning', options),
    info: (message, options) => show(message, 'info', options)
  }
}
